<template>
  <div>


    <div v-if="getModuleConfig(`${this.isSpecificPage?'staff_specific_page':'branch_page'}.form_title`)" class="page__title">
      {{ getModuleConfig(`${this.isSpecificPage?'staff_specific_page':'branch_page'}.form_title`) }}
    </div>
    <div v-if="getModuleConfig(`${this.isSpecificPage?'staff_specific_page':'branch_page'}.form_desc`)" class="page__desc">
      {{ getModuleConfig(`${this.isSpecificPage?'staff_specific_page':'branch_page'}.form_desc`) }}
    </div>


    <ShopSelection ref="shopSelection" v-model="branchId" v-if="!isSpecificPage && branchProvider" :branch-provider="branchProvider"
      :show-branch-code="false" @setBranchModel="setSelectedBranch" :placeholder="displayPlaceholder"
      @loading="handleBranchesAreLoading" @loaded="handleBranchesAreLoaded" />

    <div class="py-3">

      <div v-if="branchTitleSection && branchTitleSection.fields && selectedBranch">
        <div v-for="(group, idx) in branchTitleSection.fields" class="section branch_title_section" :key="idx">
          <div class="section__wrapper">
            <div v-for="(field, index2) in group" :key="'field' + index2" class="section__item full">
              <!-- <div class="section__title">{{ field.title }}</div> -->
              <div class="section__value">
                {{ getFieldDisplayValue(field) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="branchSubtitleSection && branchSubtitleSection.fields && selectedBranch">
        <div v-for="(group, idx) in branchSubtitleSection.fields" class="section branch_subtitle_section" :key="idx">
          <div class="section__wrapper">
            <div v-for="(field, index2) in group" :key="'field' + index2" class="section__item full">
              <!-- <div class="section__title">{{ field.title }}</div> -->
              <div class="section__value">
                {{ getFieldDisplayValue(field) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="branchDetailSection && branchDetailSection.fields && selectedBranch">
        <div v-for="(group, idx) in branchDetailSection.fields" class="section mt-3" :key="idx">
          <div class="section__wrapper">
            <div v-for="(field, index2) in group" :key="'field' + index2" class="section__item">
              <div class="section__title">{{ field.title }}</div>
              <div class="section__value">
                {{ getFieldDisplayValue(field) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="text-center branch p-3">
      <h2 class="store__name">麥味登</h2>
      <div class="store__branch">信義三店</div>
      <div>
        <img class="img-fluid store__img mt-2" src="./images/store.svg" />
      </div>
    </div>

    <div class="detail">
      <div class="row">
        <div class="col-6 mb-2">
          <div class="detail__title">店號</div>
          <div class="detail__value">293810932</div>
        </div>
        <div class="col-6 mb-2">
          <div class="detail__title">營業時間</div>
          <div class="detail__value">6:30~13:30</div>
        </div>
        <div class="col-12 mb-2">
          <div class="detail__title">聯絡電話</div>
          <div class="detail__value">02-28712871</div>
        </div>
        <div class="col-12 mb-2">
          <div class="detail__title">地址</div>
          <div class="detail__value">台北市基隆路一段147巷12號</div>
        </div>
      </div>
    </div> -->

    <div v-if="branchDetailSection && branchDetailSection.fields && selectedBranch && enableCustomerBranch" class="page__button mb-2">
      <MemberButton
        :icon-class="this.isBooking ? `mdi-message-text-outline` : `mdi-message-text`"
        :button-text="this.isBooking ? customerBranches.button_add_done_text : customerBranches.button_add_text"
        :disable-default-click="true"
        @custom-click="handleBooking" />
    </div>

    <div v-if="branchDetailSection && branchDetailSection.fields && selectedBranch && enableFavorite" class="page__button mb-2">
      <MemberButton
        :icon-class="this.isFavorite ? `mdi-star` : `mdi-star-outline`"
        :button-text="this.isFavorite ? favoriteBranches.button_add_done_text : favoriteBranches.button_add_text"
        :disable-default-click="true"
        @custom-click="handleFavorite" />
    </div>

    <div class="page__button">
      <MemberButton
        :button-text="getModuleConfig(`${this.isSpecificPage?'staff_specific_page':'branch_page'}.button_text`)"
        :button-url="getModuleConfig(`${this.isSpecificPage?'staff_specific_page':'branch_page'}.button_url`)"
        :type="getModuleConfig(`${this.isSpecificPage?'staff_specific_page':'branch_page'}.button_action`)"
      ></MemberButton>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import ShopSelection from "@/components/Page/Liff/Branch/ShopSelection";
import branchApi from "@/apis/liff/v2/branch";
import store from "@/store";

export default {
  components: {
    MemberButton,
    ShopSelection
  },
  data() {
    return {
      fetching: true,
      selectedBranch: null,
      branchId: null,
      isFavorite: false,
      isBooking: false,
    };
  },
  computed: {
    ...mapGetters("liffAuth", ["user"]),
    branchTitleSection() {
      return this.getModuleConfig("branch_page.branch_title_section");
    },
    branchSubtitleSection() {
      return this.getModuleConfig("branch_page.branch_subtitle_section");
    },
    branchDetailSection() {
      return this.getModuleConfig("branch_page.branch_detail_section");
    },
    branchProvider() {
      return this.getModuleConfig("branch_page.shop_selection.branch_provider");
    },
    showBranchCode() {
      return this.getModuleConfig("branch_page.shop_selection.show_branch_code") ?? true
    },
    favoriteBranches() {
      return this.getModuleConfig("favorite_branches")
    },
    enableFavorite() {
      return this.favoriteBranches.enable ?? false
    },
    customerBranches() {
      return this.getModuleConfig("customer_branches")
    },
    enableCustomerBranch() {
      return this.customerBranches.enable ?? false
    },
    branchChatroom() {
      return this.getModuleConfig("branche_chatroom")
    },
    enableChatRoom() {
      return this.branchChatroom.enable ?? false
    },
    gotoChatRoom() {
      return this.branchChatroom.goto_chatroom ?? false
    },
    displayPlaceholder() {
      const text = this.getModuleConfig('branch_page.shop_selection.default_select_text')
      return (text == '' || text == null || text == 'null') ? '請選擇區域櫃點' : text
    },
    isSpecificPage() {
      return this.$route.name=='LiffBranchSpecificPage'
    },
  },
  async mounted() {
    if (this.$route.params.branch_hashid){
      this.branchId = this.$route.params.branch_hashid;

      let { data } = await branchApi.getSingleBranch(this.branchId)
      if (data) {
        this.selectedBranch = data.data
      } else {
        this.$swal("分店不存在", "", "warning")
      }

    }
    else{
      this.fetchBranches();
    }
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("liff_branch", key);
    },
    async fetchBranches() {
      try {
        await this.$refs.shopSelection.fetchBranchesOptions();
      } catch (e) {
        if (!this.branchProvider) {
          this.$swal("請設定分店提供者", "", "warning");
        } else {
          console.error(e)
        }
      }
    },
    handleBranchesAreLoading() {
      this.fetching = true;
    },
    handleBranchesAreLoaded() {
      this.fetching = false;
    },
    setSelectedBranch(value) {
      this.selectedBranch = value
    },
    getFieldDisplayValue(field) {
      if (field.value) {
        return field.value.replace(/\{\{\$branch\['(.*?)'\]\}\}/g, (match, key) => {
          return this.selectedBranch[key] || ''; // 如果 `key` 存在於 `selectedBranch`，則替換，否則保留原值
        });
      } else {
        return this.selectedBranch[field.matched_key]
      }
    },
    async handleFavorite() {
      const branchName = this.selectedBranch.name;

      if (this.isFavorite) {
        let title = this.favoriteBranches.remove_confirm_text.replace(/\{\{\$branch\['name'\]\}\}/g, branchName);

        // 已為最愛，要詢問是否移除
        const result = await this.$swal({
          title: title,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '確定移除',
          cancelButtonText: '保留',
        });

        if (result.value) {
          await branchApi.removeFavorite(this.branchId);
          this.$swal('已移除我的最愛', '', 'success');
          await this.checkFavorite();
        }
      } else {
        let title = this.favoriteBranches.add_confirm_text.replace(/\{\{\$branch\['name'\]\}\}/g, branchName);

        // 尚未加入，詢問是否加入
        const result = await this.$swal({
          title: title,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '是',
          cancelButtonText: '否',
        });

        if (result.value) {
          await branchApi.addFavorite(this.branchId);
          this.$swal('已加入我的最愛', '', 'success');
          await this.checkFavorite();
        }
      }
    },
    async checkFavorite() {
      let {data} = await branchApi.isFavorite(this.branchId);
      this.isFavorite = data.data?.isFavorite ?? false;
    },
    async handleBooking() {
      const branchName = this.selectedBranch.name;

      let title = this.customerBranches.add_confirm_text.replace(/\{\{\$branch\['name'\]\}\}/g, branchName);

      // 詢問是否要開始對話
      const result = await this.$swal({
        title: title,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '是',
        cancelButtonText: '否',
      });

      if (result.value) {
        // 未綁定先綁定
        if (!this.isBooking) {
          await branchApi.bindCustomer(this.branchId);
        }

        // 如果可以創建聊天室
        if (this.enableChatRoom) {
          let response = await branchApi.createChatRoom(this.branchId);

          if (response.data.status !== 'success') {
            this.$swal({
              title: '客戶分店關聯不存在，無法繼續對話',
              type: 'error',
              button: '確定',
            });
            return;
          }

          let chatroom = response.data.data;
          // 如果可以自動導向聊天室
          if (this.gotoChatRoom) {
            const organizationCode = store.state.liffGeneral.orgCode;
            let timestamp          = this.branchChatroom.timestamp ?? '';
            let chatroomId         = chatroom.id;

            window.location.href = `/${organizationCode}/liff/chatrooms/${chatroomId}?chat=1&t=${timestamp}`;
          } else {
            await this.checkBooking();
          }
        }
      }
    },
    async checkBooking() {
      let {data} = await branchApi.isBooking(this.branchId);
      this.isBooking = data.data?.isBooking ?? false;
    }
  },
  watch: {
    selectedBranch: {
      async handler() {
        if (this.enableFavorite)
        await this.checkFavorite();
        await this.checkBooking();
      }
    }
  }
};
</script>

<style lang="scss">
// .store {
//   &__name {
//     font-size: 28px;
//     font-weight: bold;
//     color: black;
//   }

//   &__branch {
//     font-size: 20px;
//     font-weight: bold;
//     color: black;
//   }
// }

// .detail {
//   padding: 20px 12px;
//   background: white;
//   margin-bottom: 1px;

//   &__title {
//     font-weight: 400;
//     font-size: 14px;
//     color: #636366;
//   }

//   &__value {
//     font-weight: 600;
//     font-size: 18px;
//     color: #2C2C2E;
//   }
// }

.branch {
  &__title {
    font-size: 28px;

    color: black;
    text-align: center;
  }

  &__desc {
    font-size: 20px;

    color: black;
    text-align: center;
  }
}

.section {
  background: #ffffff;
  margin-bottom: 1px;
  border-radius: 10px;
  border: solid 1px #e5e5ea;
  padding: 12px;

  &__row {
    display: flex;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }

  &__wrapper {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    // .detail__row--two-col & {
    //   width: 50%;
    // }
    border-right: solid 1px #e5e5ea;
    border-bottom: solid 1px #e5e5ea;
    min-width: 50%;
    flex: 1 1 auto;
    margin: 0 -1px -1px 0;
    padding: 6px 12px;

    &.full {
      width: 100%;
    }
  }

  &__title {
    font-weight: 400;
    font-size: 14px;
    color: #636366;
  }

  &__value {
    font-size: 16px;
    color: #2c2c2e;
  }

  &__value--empty {
    font-weight: 400;
    font-size: 16px;
    color: #b7b7b7;
  }

  .is-flex & {
    margin-bottom: 8px;
  }

  &.branch_title_section {
    border: none;
    padding: 0;

    .section__item {
      border: none;
      padding: 0;
    }

    .section__value {
      font-size: 22px;
      font-weight: bold;
      color: black;
      text-align: center;
    }
  }

  &.branch_subtitle_section {
    border: none;
    padding: 0;

    .section__item {
      border: none;
      padding: 0;
    }

    .section__value {
      font-size: 20px;
      color: black;
      text-align: center;
    }
  }
}
</style>
